/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from 'react-helmet-async';

import { _mock } from 'src/_mock';
import { _financial_cost_list } from 'src/_mock/financials_assets';

import QAWrapperComponent from './QAWrapperComponent/QAWrapperComponent';

const Financials = () => {
  const _column_data: any = {
    type: {
      // 'Application Name': 'text',
      // 'Support Costs': 'currency',
      // 'Service Costs': 'currency',
      // 'License Costs': 'currency',
      // 'FTEs Costs': 'currency',
      // 'Hosting/On-Prem Cost': 'currency',
      // 'License Renewal': 'date',
      // 'Server Upgrades': 'currency',
      // 'FY': 'text',
      // 'OpEx Budget': 'currency',
      // 'CapEx Budget': 'currency',
      // 'MSP Cost': 'currency',
      // 'IT Staff Budget': 'currency',
      // 'Support Cost Type': 'singleSelect',
      // 'Service Cost Type': 'singleSelect',
      // 'Licensing Cost Type': 'singleSelect',
      'FY': 'text',
      'IT OpEx Budget': 'currency',
      'IT CapEx Budget': 'currency',
      'IT Staff Budget': 'currency',
      License: 'currency',
      Maintenance: 'currency',
      Infra: 'currency',
      Staff: 'currency',
      Hosting: 'currency',
      Upgrades: 'currency',
      'Help Desk': 'currency',
      Other: 'currency',
    },
    options: {
      // 'Support Cost Type': ['CapEx', 'OpEx'],
      // 'Service Cost Type': ['CapEx', 'OpEx'],
      // 'Licensing Cost Type': ['CapEx', 'OpEx'],
    },
    column_questions: {
      // 'Application Name': 'text',
      'Support Costs':
        'What is the total cost of the annual support contracts for this application?',
      'Service Costs':
        'What is the total annual cost of professional services from all vendors associated (PMs, Development resources, etc)?',
      'License Costs':
        'What is the total annual cost of licenses associated with the use of this application? ',
      // 'FTEs Costs': 'currency',
      'Hosting/On-Prem Cost': 'Total hosting and/or on-premise cost for the application?',
      'License Renewal': "When is the application's license renewal date?",
      'Server Upgrades': 'What is the budget for the server refresh?',
      'FY': 'Enter in the FY for the data on this row.',
      'OpEx Budget': 'What is your annual IT operating expense budget?',
      'CapEx Budget': 'What is your annual IT capital expenditure budget?',
      'MSP Cost':
        'What is your annual managed service provider or maintenance cost for your network?',
      'IT Staff Budget': 'What is your IT staff budget?',
      // 'Support Cost Type': 'singleSelect',
      // 'Service Cost Type': 'singleSelect',
      // 'Licensing Cost Type': 'singleSelect',
    },
    renderEditCell: {},
    disableEdit: {
      id: true,
      'FY': true,
      License: true,
      Maintenance: true,
      Infra: true,
      Staff: true,
      Hosting: true,
      Upgrades: true,
      'Help Desk': true,
      Other: true,
    },
    columnWidth: {
      FY: 100
    }
  };

  const gridData: any = {
    company_budgets: {
      _dataGrid_0: [...Array(10)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          'FY': _mock.fiscal_year(index),
          'IT OpEx Budget': _mock.opex_budget(index),
          'IT CapEx Budget': _mock.capex_budget(index),
          // 'MSP Cost': _mock.network_cost(index),
          'IT Staff Budget': _mock.it_staff_budget(index),
          // Staff: _financial_cost_list.Staff_0[index],
          // Hosting: _financial_cost_list.Hosting_0[index],
          // Upgrades: _financial_cost_list.Upgrades_0[index],
          // 'Help Desk': _financial_cost_list[`Help Desk_0`][index],
          // Other: _financial_cost_list.Other_0[index],
          // 'Support Cost Type': _mock.support_cost_type(index),
          // 'Service Cost Type': _mock.services_cost_type(index),
          // 'Licensing Cost Type': _mock.license_cost_type(index),
        };
      }),
    },
    actual_budgets: {
      _dataGrid_0: [...Array(10)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          'FY': _mock.fiscal_year(index),
          License: _financial_cost_list.License_0[index],
          Maintenance: _financial_cost_list.Maintenance_0[index],
          Infra: _financial_cost_list.Infra_0[index],
          Staff: _financial_cost_list.Staff_0[index],
          Hosting: _financial_cost_list.Hosting_0[index],
          Upgrades: _financial_cost_list.Upgrades_0[index],
          'Help Desk': _financial_cost_list[`Help Desk_0`][index],
          Other: _financial_cost_list.Other_0[index],
        };
      }),
    },
  };
  const TABS = [
    // { value: 'application_financials', label: 'Application Financials', color: 'success' },
    {
      value: 'company_budgets',
      label: 'Budgets',
      color: 'default',
    },
    {
      value: 'actual_budgets',
      label: 'Actuals',
      color: 'default',
    },
  ] as const;

  return (
    <>
      <Helmet>
        <title> Dashboard: Financials</title>
      </Helmet>

      <QAWrapperComponent
        TABS={TABS}
        gridData={gridData}
        _column_data={_column_data}
        title="Financials"
      />
    </>
  );
};

export default Financials;
